import { render, staticRenderFns } from "./material_table.vue?vue&type=template&id=b91534d0&scoped=true"
import script from "./material_table.vue?vue&type=script&lang=js"
export * from "./material_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91534d0",
  null
  
)

export default component.exports